/**
 * Abuse-report categories, shared by the /report-abuse form (client) and the
 * /api/report-abuse proxy (server). Must match the backend's
 * POST /v1/abuse-reports `category` values. Import-free on purpose so the
 * client bundle can use it.
 */
export const ABUSE_CATEGORIES = ['phishing', 'malware', 'spam', 'illegal_content', 'other'] as const;

export type AbuseCategory = (typeof ABUSE_CATEGORIES)[number];

export const ABUSE_CATEGORY_LABELS: Record<AbuseCategory, string> = {
  phishing: 'Phishing or credential theft',
  malware: 'Malware or unwanted software',
  spam: 'Spam',
  illegal_content: 'Illegal content',
  other: 'Something else',
};
